/**
 * *****************************************************************************************************************
 * Table component. Will render a narrow and wide table depending on the css container query, thus making it mobile
 * friendly. In order for the table to render correctly in mobile and desktop, the parent container must have a
 * container query. Observing window resizing with react is not optimal for a table component. Thus, this needs
 * to be done with css.
 * ********************
 *
 * @format
 */

import {NarrowTable} from './narrow_table';
import {WideTable} from './wide_table';
import React from 'react';

export const Table = props => {
    return (
        <div className="table-common-65gq">
            <div className="table-common-65gq__wide">
                <WideTable {...props} />
            </div>
            <div className="table-common-65gq__narrow">
                {' '}
                <NarrowTable {...props} />
            </div>
        </div>
    );
};
